import { useQuery } from "@tanstack/react-query";
import { getClefs } from "../api/CLEF/clef";

export function useGetApiKeys() {
  return useQuery({
    queryKey: ["api-keys"],
    queryFn: getClefs,
  });
}
